// ==================== FILE: src/components/FlowBuilder/utils/flowTemplates.js ====================
import { MarkerType } from 'reactflow';

export const loadTemplateFlows = (templateId, handleEdit, handleDelete, handleDuplicate) => {
  const templates = {
    'cart-recovery': {
      name: 'Abandoned Cart Recovery',
      nodes: [
        {
          id: 'start',
          type: 'startNode',
          position: { x: 100, y: 100 },
          data: {
            id: 'start',
            label: 'Cart Abandoned',
            triggerType: 'event',
            eventName: 'cart_abandoned',
            onEdit: handleEdit,
          },
        },
        {
          id: 'msg1',
          type: 'actionNode',
          position: { x: 100, y: 250 },
          data: {
            id: 'msg1',
            label: 'Send Reminder',
            channel: 'whatsapp',
            template: 'Your cart is waiting! Complete your purchase now.',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'wait1',
          type: 'delayNode',
          position: { x: 100, y: 400 },
          data: {
            id: 'wait1',
            label: 'Wait 1 Day',
            duration: '1',
            unit: 'days',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'cond1',
          type: 'conditionNode',
          position: { x: 50, y: 550 },
          data: {
            id: 'cond1',
            label: 'Cart Converted?',
            eventSource: 'Cart Converted',
            conditionLogic: 'occurred',
            yesLabel: 'Purchased',
            noLabel: 'Not Yet',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'end-yes',
          type: 'endNode',
          position: { x: 50, y: 750 },
          data: { id: 'end-yes', label: 'End' },
        },
        {
          id: 'msg2',
          type: 'actionNode',
          position: { x: 350, y: 750 },
          data: {
            id: 'msg2',
            label: 'Send Follow-up',
            channel: 'sms',
            template: 'Last chance! 10% off your cart items.',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'end-no',
          type: 'endNode',
          position: { x: 350, y: 900 },
          data: { id: 'end-no', label: 'End' },
        },
      ],
      edges: [
        {
          id: 'e1',
          source: 'start',
          target: 'msg1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e2',
          source: 'msg1',
          target: 'wait1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e3',
          source: 'wait1',
          target: 'cond1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e4',
          source: 'cond1',
          sourceHandle: 'yes',
          target: 'end-yes',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
          label: 'Yes',
        },
        {
          id: 'e5',
          source: 'cond1',
          sourceHandle: 'no',
          target: 'msg2',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
          label: 'No',
        },
        {
          id: 'e6',
          source: 'msg2',
          target: 'end-no',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
      ],
    },
    'promo-redemption': {
      name: 'Promo Code Redemption',
      nodes: [
        {
          id: 'start',
          type: 'startNode',
          position: { x: 100, y: 50 },
          data: {
            id: 'start',
            label: 'Campaign Start',
            triggerType: 'manual',
            onEdit: handleEdit,
          },
        },
        {
          id: 'msg1',
          type: 'actionNode',
          position: { x: 100, y: 200 },
          data: {
            id: 'msg1',
            label: 'Send Promo Code',
            channel: 'email',
            template: 'Use code {{promo_code}} for 20% off!',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'wait1',
          type: 'delayNode',
          position: { x: 100, y: 350 },
          data: {
            id: 'wait1',
            label: 'Wait 7 Days',
            duration: '7',
            unit: 'days',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'end',
          type: 'endNode',
          position: { x: 125, y: 500 },
          data: { id: 'end', label: 'End' },
        },
      ],
      edges: [
        {
          id: 'e1',
          source: 'start',
          target: 'msg1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e2',
          source: 'msg1',
          target: 'wait1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e3',
          source: 'wait1',
          target: 'end',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
      ],
    },
    'trial-conversion': {
      name: 'Trial Conversion',
      nodes: [
        {
          id: 'start',
          type: 'startNode',
          position: { x: 100, y: 50 },
          data: {
            id: 'start',
            label: 'Trial Started',
            triggerType: 'event',
            eventName: 'trial_started',
            onEdit: handleEdit,
          },
        },
        {
          id: 'wait1',
          type: 'delayNode',
          position: { x: 100, y: 200 },
          data: {
            id: 'wait1',
            label: 'Wait 5 Days',
            duration: '5',
            unit: 'days',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'msg1',
          type: 'actionNode',
          position: { x: 100, y: 350 },
          data: {
            id: 'msg1',
            label: 'Upgrade Offer',
            channel: 'email',
            template: '2 days left in your trial! Upgrade now and save 20%.',
            onEdit: handleEdit,
            onDelete: handleDelete,
            onDuplicate: handleDuplicate,
          },
        },
        {
          id: 'end',
          type: 'endNode',
          position: { x: 125, y: 500 },
          data: { id: 'end', label: 'End' },
        },
      ],
      edges: [
        {
          id: 'e1',
          source: 'start',
          target: 'wait1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e2',
          source: 'wait1',
          target: 'msg1',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
        {
          id: 'e3',
          source: 'msg1',
          target: 'end',
          type: 'smoothstep',
          animated: true,
          markerEnd: { type: MarkerType.ArrowClosed },
        },
      ],
    },
  };

  return templates[templateId] || null;
};